import { Empty } from 'antd'
import React from 'react'

import { SVGs } from '../../../assets'
import { BitazzaText } from '../Typography/Text'
import Style from './EmptyResult.module.scss'

interface Props {
    description: string
}

export const EmptyResult: React.FC<Props> = ({ description }) => (
    <Empty
        image={SVGs.emptyResult}
        imageStyle={{
            height: 60,
        }}
        description={
            <div className={Style.container}>
                <BitazzaText
                    content={description}
                    color="#86A1A1"
                    format="t16"
                    textAlign="center"
                />
            </div>
        }
    ></Empty>
)
